import { useMemo } from 'react';

import { useEndpoint } from '../../../../api/hooks/endpoint/useEndpoint';
import {
  CUSTOM_FIELD_ITEM_TABS,
  getCustomFieldItemColumnDefinition
} from '../../../../schema/custom-field/custom-field.schema';
import { EntityTable } from '../../../common/entity-table/EntityTable';

export const CustomFieldItemsTable = () => {
  const itemsQuery = useEndpoint('/custom/fields/items', 'customFieldItems');
  const fieldsQuery = useEndpoint('/custom/fields', 'customFields');

  const tabs = useMemo(
    () => CUSTOM_FIELD_ITEM_TABS(fieldsQuery.data ?? []),
    [fieldsQuery.data]
  );

  return (
    <EntityTable
      query={itemsQuery}
      getColumnDefinition={getCustomFieldItemColumnDefinition}
      entityTabs={tabs}
      entityName="Meal Item"
      canExport={false}
    />
  );
};
